/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Internal Imports
 */
import FeedbackTable from '../../components/customTables/tasks/feedbackTable';
import SearchHeader from '../../components/searchHeader';

/**
 * Style Imports
 */
import { TaskContainer } from './styles/Support.styles';

interface FeedbackPageProps {
  searchTerm: string;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}

const SupportFeedback: FC<FeedbackPageProps> = ({
  searchTerm,
  setSearchTerm
}) => {
  return (
    <TaskContainer id="Support-Feedback">
      <SearchHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <FeedbackTable searchTerm={searchTerm} />
    </TaskContainer>
  );
};

export default SupportFeedback;
